<section class="matches-list">
  <div class="matches-list__header">
    <div class="matches-list__header-actions">
      <div class="matches-list__header-title">
        {{ "UpcomingMatches" | translate }}
      </div>
      <div class="filter-toggle-btn" (click)="toggleFilters()" *ngIf="isMobile">
        <i class="fas fa-sliders-h"></i>
      </div>
    </div>

    <form
      [formGroup]="matchesFiltersForm"
      class="matches-list__header-filters"
      [ngClass]="{ 'mobile-filters-visible': isMobile && showFilters }"
    >
      <div>
        <app-evento-select
          [eventoFormControl]="matchesFiltersForm.get('team')"
          placeholder="{{ 'Team' | translate }}"
          [items]="teams"
          [multiple]="false"
          (changeEvent)="onFilterChange()"
        >
        </app-evento-select>
      </div>

      <div>
        <app-evento-select
          [eventoFormControl]="matchesFiltersForm.get('champion')"
          placeholder="{{ 'Champion' | translate }}"
          [items]="champions"
          [multiple]="false"
          (changeEvent)="onFilterChange()"
        >
        </app-evento-select>
      </div>

      <div>
        <app-evento-select
          [eventoFormControl]="matchesFiltersForm.get('city')"
          placeholder="{{ 'City' | translate }}"
          [items]="cities"
          [multiple]="false"
          (changeEvent)="onFilterChange()"
        >
        </app-evento-select>
      </div>

      <div>
        <app-evento-select
          [eventoFormControl]="matchesFiltersForm.get('stadium')"
          placeholder="{{ 'Stadium' | translate }}"
          [items]="stadiums"
          [multiple]="false"
          (changeEvent)="onFilterChange()"
        >
        </app-evento-select>
      </div>

      <div class="date-picker-container">
        <button class="date-picker-button" (click)="openDatePicker()">
          {{ "PickFromCalendar" | translate }}
          <img [src]="'assets/images/icons/white-calendar.svg'" />
        </button>

        <input
          type="text"
          bsDaterangepicker
          #datePicker="bsDaterangepicker"
          [bsConfig]="{
            containerClass: 'theme-dark-blue',
            rangeInputFormat: 'MM/DD/YYYY',
            dateInputFormat: 'MM/DD/YYYY',
            showWeekNumbers: false,
            displayMonths: 1
          }"
          formControlName="date"
          (bsValueChange)="onDateSelected()"
          class="hidden-input"
        />
      </div>
    </form>
  </div>

  <div *ngIf="selectedDateRange" class="selected-date-range">
    {{ "AvailableMatches" | translate : selectedDateRange }}
  </div>

  <div
    *ngIf="matches && matches.length > 0; else loadingSkeletons"
    class="row matches-list__cards"
  >
    <div
      *ngFor="let match of matches"
      class="col-sm-12 col-md-6 col-lg-4 col-xl-3"
    >
      <app-match-card [match]="match"></app-match-card>
    </div>
  </div>

  <ng-template #loadingSkeletons>
    <div class="row matches-list__cards">
      <div
        *ngFor="let skeleton of [].constructor(8)"
        class="col-sm-12 col-md-6 col-lg-4 col-xl-3"
      >
        <div class="eventCard skeleton">
          <div class="eventCard-cover ratio-wrapper">
            <div
              class="skeleton-box skeleton-box__image ratio-wrapper__el"
            ></div>
          </div>

          <div class="eventCard-body">
            <p class="eventCard-cardTitle">
              <span class="skeleton-box"></span>
            </p>
            <span class="eventCard-cardDate">
              <span class="skeleton-box" style="max-width: 50%"></span>
            </span>
            <p class="eventCard-cardText">
              <span class="skeleton-box"></span>
              <span class="skeleton-box" style="max-width: 80%"></span>
              <span class="skeleton-box" style="max-width: 60%"></span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <app-nodata
    title="{{ 'No Results Found' | translate }}"
    desc=""
    link=""
    *ngIf="!isLoadingMatches && !matches.length"
    img="assets/images/reports/no-reports.png"
  ></app-nodata>
  <app-pagination
    *ngIf="matchesMeta && !isLoadingMatches"
    [meta]="matchesMeta"
    (goPage)="goToPage($event)"
    (goNext)="onNext()"
    (goPrev)="onPrev()"
  >
  </app-pagination>
</section>
<app-footer></app-footer>
